<div class="mt-4">
    <div class="welcome-screen container-sm mt-5 pt-5">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card shadow-lg p-5">
                  <!-- Señuelos (OBLIGATORIOS) -->
                  <input type="text"
                         autocomplete="username"
                         name="fake-username"
                         tabindex="-1"
                         aria-hidden="true"
                         style="position:absolute; left:-9999px; opacity:0">

                  <input type="password"
                         autocomplete="current-password"
                         name="fake-password"
                         tabindex="-1"
                         aria-hidden="true"
                         style="position:absolute; left:-9999px; opacity:0">

                  <form [formGroup]="signatureForm" autocomplete="off">
                        <h2 class="title text-center"><i class="fas fa-key"></i> {{"TITLE.CREDENTIAL-CERTIFICATE" | translate}}
                         </h2>
                        <hr>
                        <div class="row alert {{alertType}} custom-alert" *ngIf="showMsg" id="customAlert">
                                <span class="alert-icon">
                                    <i class="fa-2x  {{icon}} {{alertType === 'alert-danger' ? 'text-danger': (this.alertType ==='alert-warning' ? 'text-warning': 'text-info')}}"></i>&nbsp;</span>
                            <div class="alert-content {{alertType}} font-weight-normal">
                                <div [innerHTML]="messageAlert | translate"></div>
                            </div>
                        </div>
                        <div class="">
                            <label for="usernameForm"><b>{{ "MESSAGE.ENTER-USER" | translate }}:</b></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-user"></i>
                                    </div>
                                </div>
                                <input type="text" id="usernameForm"
                                       (keyup)="search($event)"
                                       (change)="onSignboxDataChanged()"
                                       placeholder="{{ 'MESSAGE.ENTER-USER' | translate }}..."
                                       autocomplete="off"
                                       list="signboxList"
                                       [attr.disabled]="signCompleted ? '' : null"
                                       [class.is-invalid]="isInvalidControl('username')"
                                       class="form-control"
                                       formControlName="username" placeholder="Ingrese usuario de certificado">
                                <datalist id="signboxList" *ngIf="uanatacasignboxdatas">
                                    <option *ngFor="let uanatacasignboxdata of this.uanatacasignboxdatas"
                                            [ngValue]="uanatacasignboxdata">
                                        {{uanatacasignboxdata.user}} - {{uanatacasignboxdata.reason}}
                                    </option>
                                </datalist>
                            </div>
                            <div>
                                <small *ngIf="isInvalidControl('username')"
                                       class="text-danger">
                                    {{ "MESSAGE.ENTER-USER" | translate }}
                                </small>
                            </div>
                        </div>
                        <div class="mt-1">
                            <label for="password"><b>{{ "MESSAGE.ENTER-PASSWORD" | translate }}:</b></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fas fa-lock"></i>
                                    </span>
                                </div>
                                <input type="text"
                                       id="password"
                                       class="form-control"
                                       placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}..."
                                       formControlName="password"
                                       name="secure-password-field"
                                       autocomplete="new-password"
                                       spellcheck="false"
                                       autocapitalize="off"
                                       [class.masked-input]="!viewPassword"
                                       [attr.disabled]="signCompleted ? '' : null"
                                       [class.is-invalid]="isInvalidControl('password')">
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <i class="fa {{viewPassword?'fa-eye':'fa-eye-slash'}}"
                                           (click)="toggleFieldTextType(PASSWORD)"></i></span>
                                </div>
                            </div>
                            <div><small *ngIf="isInvalidControl('password')"
                                        class="text-danger">
                                {{ "MESSAGE.ENTER-PASSWORD" | translate }}
                            </small>
                            </div>
                        </div>
                        <div class="mt-1">
                            <label for="pin"><b>Ingrese el Pin:</b></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fas fa-lock"></i>
                                    </span>
                                </div>
                                <input type="text"
                                       id="pin"
                                       class="form-control"
                                       placeholder="Ingrese pin"
                                       formControlName="pin"
                                       name="secure-pin-field"
                                       autocomplete="one-time-code"
                                       inputmode="numeric"
                                       spellcheck="false"
                                       [class.masked-input]="!viewPin"
                                       [attr.disabled]="signCompleted ? '' : null"
                                       [class.is-invalid]="isInvalidControl('pin')">
                                <div class="input-group-append"><span class="input-group-text">
                                    <i class="fa {{viewPin?'fa-eye':'fa-eye-slash'}}"
                                       (click)="toggleFieldTextType(PIN)"></i>
                                </span>
                                </div>
                            </div>
                            <div>
                                <small *ngIf="isInvalidControl('pin')"
                                       class="text-danger">
                                    {{ "MESSAGE.ENTER-PIN" | translate }}
                                </small>
                            </div>
                        </div>
                        <div class="mt-1">
                            <label for="country"><b>{{ "LABEL.LOCALIZATION" | translate }}:</b></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-globe"></i>
                                    </div>
                                </div>
                                <select class="form-control"
                                        id="country"
                                        formControlName="country"
                                        [class.is-invalid]="isInvalidControl('country')">
                                    <option *ngFor="let country of countries"
                                            [value]="country.id"> {{country.name | translate}} </option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-1">
                            <label for="password"><b>{{ "LABEL.REASON-FOR-SIGNATURE" | translate }}:</b></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-text-height" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <input type="text"
                                       id="reason"
                                       class="form-control col-md-12 offset-md-0"
                                       placeholder="{{ 'MESSAGE.ENTER-REASON-SIGNATURE' | translate }}"
                                       formControlName="reason"
                                       autocomplete="off"
                                       [class.is-invalid]="isInvalidControl('reason')">
                            </div>
                        </div>
                        <div class="row mt-1" *ngIf="hasCertificateDueDate(certificateDueDate)">
                            <div class="col-md-5 font-weight-bold custom-div-sign-remote {{hasCertificateDueDate(certificateDueDate)?'':'custom-div-certificate-hidden'}}">
                                {{ "LABEL.CERTIFICATE-EXPIRATION" | translate }}:
                            </div>
                            <div class="col font-weight-light custom-button-sign-remote {{isCertificateDueDateCorrect(certificateDueDate)?'custom-div-certificate-ok':'custom-div-certificate-error'}} {{hasCertificateDueDate(certificateDueDate)?'':'custom-div-certificate-hidden'}}">{{certificateDueDate | dateformat}}</div>
                        </div>
                    </form>
                    <div class="card-footer text-center">
                        <div class="buttons">
                            <button (click)="goBack()" class="btn btn-danger">
                                <i class="fa fa-reply" aria-hidden="true"></i> {{"BUTTON.BACK" | translate}}
                            </button>
                            &nbsp;
                            <button class="submit btn btn-success" (click)="signDocument()">
                                <i class="fa fa-signature" aria-hidden="true"></i> {{"BUTTON.SIGN" | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="loading"></app-loading>
